import { faFilePdf, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import sparkLogo from "../../images/spark.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

function ExportPDF({ targetRef }) {
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.auth);
  const [isExporting, setIsExporting] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState();

  useEffect(() => {
    if (auth?.admin?.photo) {
      setProfilePhoto(auth.admin.photo);
    } else {
      setProfilePhoto();
    }
  }, [auth]);

  const handleExport = async () => {
    if (!targetRef?.current) return;
    setIsExporting(true);

    try {
      const element = targetRef.current;
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      // Parameters: img, format, x, y, width, height
      pdf.addImage(sparkLogo, "PNG", 10, 5, 40, 14);
      // if (profilePhoto) {
      //   pdf.addImage(profilePhoto, "PNG", pdfWidth - 50, 5, 40, 10);
      // }

      pdf.addImage(imgData, "PNG", 0, 25, pdfWidth, pdfHeight);

      pdf.save("presentation-report.pdf");
    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex justify-end">
      <button
        onClick={handleExport}
        disabled={isExporting} // Disable button while loading
        className={`bg-red-600 text-sm text-white rounded-lg p-2 hover:bg-red-700 uppercase flex items-center ${
          isExporting ? "opacity-75 cursor-not-allowed" : ""
        }`}
      >
        <FontAwesomeIcon
          icon={isExporting ? faSpinner : faFilePdf}
          className={`mr-1 ${isExporting ? "animate-spin" : ""}`}
        />
        {isExporting ? "Exporting..." : "Export PDF"}
      </button>
    </div>
  );
}

export default ExportPDF;
